import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hashtag_338fc98eca7e994209ed864305018710",
  "use": "hashtag_338fc98eca7e994209ed864305018710-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"hashtag_338fc98eca7e994209ed864305018710\">\n    <path fill-rule=\"evenodd\" d=\"M11.43 6.719l-.558 2.627h2.234v1.346h-2.505L9.9 14H8.527l.702-3.308H5.862L5.16 14H3.787l.702-3.308H2V9.346h2.76l.56-2.627H2.91V5.357h2.696L6.31 2H7.68l-.702 3.357h3.367L11.048 2h1.372l-.702 3.357H14v1.362h-2.57zm-1.371 0H6.69l-.558 2.627H9.5l.559-2.627z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol